export default "__VITE_ASSET__DpscbSB1__"